<template>
<div>
  <h4>Kontakt</h4>
  
  <form action="" class="form-horizontal" @submit.prevent="submit">
    <form-group label="Dane firmy" :error="errors['contact.companyData']">
      <textarea-input v-model="contact.companyData" rows="10"></textarea-input>
    </form-group>
    
    <form-group label="Telefony" :error="errors['contact.phonesData']">
      <textarea-input v-model="contact.phonesData" rows="10"></textarea-input>
    </form-group>
    
    <form-group label="Email do wiadomości" :error="errors['contact.contactEmail']">
      <text-input v-model="contact.contactEmail"></text-input>
    </form-group>
    
    <submit-button :submitting="submitting"></submit-button>
  </form>
</div>
</template>
<script>
import SubmitButton from './SubmitButton.vue'
import FormGroup from './FormGroup.vue'
import TextareaInput from './TextareaInput.vue'
import TextInput from './TextInput.vue'
import Flash from './../Flash'
import Api from './../api'

export default {
  data () {
    return {
      errors: [],
      submitting: false,
      contact: {
        companyData: '',
        phonesData: '',
        contactEmail: ''
      }
    }
  },
  components: {
    SubmitButton,
    FormGroup,
    TextareaInput,
    TextInput
  },
  methods: {
    submit () {
      this.errors = []
      this.submitting = true
      Api.contact.put(this.contact).then(this.onSubmitSuccess, this.updateError).then(() => { this.submitting = false })
    },
    onSubmitSuccess () {
      Flash.success('Zaktualizowano dane kontaktowe poprawnie')
    },
    updateError () {
      Flash.error('Niestety nie udało się zaktualizować danych kontaktowych, skontaktuj się z administratorem')
    },
    fetchData () {
      Api.contact.get().then(this.fetchSuccess)
    },
    fetchSuccess ({ body }) {
      this.contact = body
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Contact.vue?44c7379f